import { render } from "./AddPartner.vue?vue&type=template&id=21a5c4fb"
import script from "./AddPartner.vue?vue&type=script&lang=js"
export * from "./AddPartner.vue?vue&type=script&lang=js"

import "./AddPartner.vue?vue&type=style&index=0&id=21a5c4fb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__